import smoothscroll from 'smoothscroll-polyfill';
export default class AlphabeticIndexSmoothScroll {
  constructor() {
    this.indexes = document.querySelectorAll('.a-z-index');
    this.buffer = 20;
    if(this.indexes.length) {
      smoothscroll.polyfill();
    }
    for(let i = 0; i < this.indexes.length; i += 1) {
      const anchorLinks = this.indexes[i].querySelectorAll('a[href^="#"]');
      for(let a = 0; a < anchorLinks.length; a += 1) {
        anchorLinks[a].addEventListener('click', (e) => this.smoothScroll(e, anchorLinks[a]));
      }
    }
  }
  smoothScroll(e, el) {
    e.preventDefault();
    const targetString = el.getAttribute('href').replace(/^#/, '');
    const idEl = document.getElementById(targetString);
    const nameEls = document.getElementsByName(targetString);
    const targetEl = idEl ? idEl :
                     nameEls ? nameEls[0] :
                     null;
    if(targetEl) {
      let {top} = targetEl.getBoundingClientRect();
      top -= this.getBuffer();
      window.scrollBy({
        behavior: 'smooth',
        top
      });
    }
  }
  getBuffer() {
    const header = document.querySelector('.pageheader');
    const headerSpace = header ? header.offsetHeight : 0;
    return this.buffer + headerSpace;
  }
}